import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';

export default function decorateurRectangleReseauxNumeriques(rectangle) {
  rectangle.stroke = niveauDispo.COULEUR_DISPO_DISPONIBLE;
  rectangle.fill = niveauDispo.COULEUR_BLANCHE;
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurRectangleReseauxNumeriques.js